'use client';

import { SectionHeading } from "@/components/taller/section-heading";
import { TallerButtonLink } from "@/components/taller/button";
import { useTranslations } from "@/i18n/client";
import { plans } from "@/content/plans";
import { Reveal } from "@/components/ui/reveal";

/** Modern Planes section with surface background. */
export function Planes() {
  const { t, isLoading } = useTranslations();
  const planes = t('planes');

  if (isLoading) return null;

  const items = planes.items ?? plans.map((p) => ({
    name: p.name,
    tag: p.tag,
    sub: p.sub,
    features: p.features as [string, string, string, string, string],
  }));

  return (
    <section className="bg-[var(--color-surface)] py-24 md:py-32">
      <div className="max-w-[var(--container-max)] mx-auto px-6 md:px-14">
        <SectionHeading
          overline={planes.overline || 'Planes'}
          heading={
            <>
              {planes.heading || 'Tres caminos. '}
              <em>{planes.headingAccent || 'Uno empieza en cero.'}</em>
            </>
          }
          className="mb-16"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((plan, i) => (
            <Reveal key={plan.name} delay={i * 0.1} width="100%">
              <div
                className="bg-[var(--color-bg)] p-8 rounded-[var(--radius-lg)] border border-[var(--color-border)] flex flex-col gap-6 h-full"
              >
                <div>
                  <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[var(--color-accent)] mb-3">
                    {plan.tag}
                  </div>
                  <div className="font-sans font-bold text-[28px] tracking-tight text-[var(--color-ink)]">
                    {plan.name}
                  </div>
                  <div className="font-mono text-[11px] tracking-widest uppercase text-[var(--color-mute)] mt-1">
                    {plan.sub}
                  </div>
                </div>
                <ul className="list-none p-0 m-0 flex flex-col gap-3 flex-1">
                  {plan.features.map((feat) => (
                    <li key={feat} className="flex items-center gap-3 font-sans text-[14px] text-[var(--color-mute)]">
                      <span className="text-[var(--color-accent)] font-mono text-[10px]">↳</span>
                      {feat}
                    </li>
                  ))}
                </ul>

                <TallerButtonLink 
                  variant={i === 1 ? "primary" : "secondary"} 
                  href="/contacto" 
                  size="sm"
                  className="w-full"
                >
                  {i === 2 ? 'Contactar' : 'Empezar ahora'}
                </TallerButtonLink>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
